import { useState, useEffect } from "react";
import CheckpointApi from "../services/checkpointApi";

export default function useLatestCheckpoints() {
  const [checkpoints, setCheckpoints] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function fetchCheckpoints() {
      try {
        const response = await CheckpointApi.getLatestCheckpoints();
        if (mounted) {
          setCheckpoints(response?.items || []);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching latest checkpoints:", error);
        if (mounted) {
          setCheckpoints([]);
          setLoading(false);
        }
      }
    }

    fetchCheckpoints();

    // Poll for updates every 10 seconds
    const interval = setInterval(fetchCheckpoints, 10000);

    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, []);

  return { checkpoints, loading };
}
